import { typeChecker } from './type-checker';
const { validObj } = typeChecker;

let requestCache = {};

/**
 * Serializes an object into a URL parameters string.
 * @param {Object} obj
 * @returns String
 */
const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
};

/**
 * Makes the API request to get the currency data.
 * @param {String} url (endpoint)
 * @param {Object} data (in case we need to send something via POST)
 * @param {String} method (GET or POST)
 * @param {Object} headers (pair key-value object to send as request headers)
 * @returns Promise
 */
export const loadPromiseDataFromApi = function ({ url = '', data = {}, method = 'GET', headers = {}, type = 'text' }) {

  const stringKey = JSON.stringify({ url, data });
  if (!requestCache[stringKey]) {
    return (requestCache[stringKey] = new Promise(function (resolve, reject) {
      let httpRequest = new XMLHttpRequest();
      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState == 4 && httpRequest.status == 200) {
          let response = type === 'text' ? httpRequest.responseText : JSON.parse(httpRequest.responseText);
          requestCache[stringKey] = response;
          resolve(response);
        } else if (httpRequest.readyState == 4 && httpRequest.status !== 200) {
          reject(httpRequest.response);
        }
      };
      httpRequest.open(method, url);
      if (validObj(data)) {
        httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      }
      for (const key in headers) {
        httpRequest.setRequestHeader(key, headers[key]);
      }
      httpRequest.send(serialize(data));
    }));
  }
  return Promise.resolve(requestCache[stringKey]);
};
